import adminTable from "@store/adminTable/reducers";

import { topic } from "@Modules/Topic/configs/constants";

export default adminTable(topic);
